module.exports = __webpack_public_path__ + "static/media/plus.7b1186f4.jpg";